import { Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { CommunitiesTypeFilter } from '../feed/CommunitiesTypeFilter';
import { LocationAndZoneFilters } from '../feed/LocationAndZoneFilters';

interface Community {
  id: string;
  name: string;
  members_count?: number;
}

interface MobileDiscoverFilterSheetProps {
  selectedCommunity: string;
  onCommunityChange: (value: string) => void;
  locationFilter: string;
  onLocationFilterChange: (value: string) => void;
  communities: Community[];
  communitiesLoading: boolean;
  showFilters: boolean;
  onToggleFilters: () => void;
}

export const MobileDiscoverFilterSheet = ({
  selectedCommunity,
  onCommunityChange,
  locationFilter,
  onLocationFilterChange,
  communities,
  communitiesLoading,
  showFilters,
  onToggleFilters
}: MobileDiscoverFilterSheetProps) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`h-8 ${showFilters ? 'bg-primary text-primary-foreground' : ''}`}
          onClick={onToggleFilters}
        >
          <Filter className="w-4 h-4 mr-1" />
          Filters
        </Button>
      </SheetTrigger>
        <SheetContent side="bottom" className="h-[100svh] overflow-hidden p-0">
          <SheetHeader>
            <SheetTitle>Filter Farms</SheetTitle>
            <SheetDescription>
              Filter farms by community and location preferences.
            </SheetDescription>
          </SheetHeader>
          
          <div className="space-y-4 mt-4">
            <CommunitiesTypeFilter 
              selectedCommunity={selectedCommunity}
              onCommunityChange={onCommunityChange}
            />

            <LocationAndZoneFilters 
              locationFilter={locationFilter}
              onLocationFilterChange={onLocationFilterChange}
            />
            
            {/* Mobile Login to Join Community Message */}
            <div className="text-center py-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-xs font-medium text-blue-800">
                🌱 Login to Join a Community - Connect & share with local farmers
              </p>
            </div>
          </div>
      </SheetContent>
    </Sheet>
  );
};